<template>
  <div>
    <h2>Lock Status Tracker</h2>
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">Lock</th>
          <th scope="col">Status</th>
          <th v-if="is_admin_or_standard" scope="col">Send Command</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="device in lock_devices" :key="device.device_id">
          <td>{{device.device_name}}</td>
          <transition name="fade">
            <td v-if="isUnlocked(device.device_id)">
              <i v-if="isJammed(device.device_id)" style="color: red;" class="fa-solid fa-circle-exclamation fa-lg" title="The lock is jammed."></i>&nbsp;
              <i style="color: orange;" class="fa fa-unlock fa-lg" title="The lock is unlocked."></i>&nbsp;&nbsp; Unlocked
            </td>
            <td v-if="isLocked(device.device_id)">
              <i v-if="isJammed(device.device_id)" style="color: red;" class="fa-solid fa-circle-exclamation fa-lg" title="The lock is jammed."></i>&nbsp;
              <i style="color: green;" class="fa fa-lock fa-lg" title="The lock is locked."></i>&nbsp;&nbsp; Locked
            </td>
            <td v-if="isUnknown(device.device_id)">
              <i v-if="isJammed(device.device_id)" style="color: red;" class="fa-solid fa-circle-exclamation fa-lg" title="The lock is jammed."></i>&nbsp;
              <i class="fa fa-circle-question fa-lg" title="The lock status is unknown."></i>&nbsp;&nbsp; Unknown
            </td>
          </transition>
          <td v-if="[1, 2, 3, 4].includes(logged_in_user.group_id)">
            <a v-if="isUnlocked(device.device_id, true)" href="#"
              @click="lockHavenLock(device.device_id)">
              Lock
            </a>
            <a v-if="isLocked(device.device_id)" href="#"
              @click="unlockHavenLock(device.device_id)">
              Unlock
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script type="text">
import { mapGetters } from 'vuex'
import HavenLockMixin from '@/mixins/HavenLockMixin'

export default {
  name: 'HavenLockWidget',
  mixins: [HavenLockMixin],
  computed: {
    ...mapGetters({
      logged_in_user: 'loggedInUser'
    }),
    is_admin_or_standard: function () {
      return [1, 2, 3, 4].includes(this.logged_in_user.group_id)
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 1.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>